module.exports = __webpack_public_path__ + "img/create-link.732b2af1.svg";